module.exports = __webpack_public_path__ + "static/media/map_with_markers.1815cd34.png";